import { For, createSignal } from 'solid-js';
import { Portal } from 'solid-js/web';

export type ToastKind = 'success' | 'error' | 'info' | 'warning';

interface ToastItem {
  id: number;
  kind: ToastKind;
  text: string;
  ttl: number;
}

let pushToastInternal: ((kind: ToastKind, text: string, ttl?: number) => void) | null = null;
export function showToast(kind: ToastKind, text: string, ttl = 5000) {
  if (pushToastInternal) pushToastInternal(kind, text, ttl);
}
(window as any).__memePumpShowToast = showToast;

export default function ToastNotification() {
  const [items, setItems] = createSignal<ToastItem[]>([]);
  let nextId = 1;

  const remove = (id: number) => setItems(list => list.filter(t => t.id !== id));

  const push = (kind: ToastKind, text: string, ttl = 5000) => {
    const id = nextId++;
    const safeTtl = Math.max(5000, ttl);
    const entry: ToastItem = { id, kind, text, ttl: safeTtl };
    setItems(list => [entry, ...list]);
    setTimeout(() => remove(id), safeTtl);
  };
  pushToastInternal = push;

  const cardClass = (k: ToastKind) => `mp-toast ${k}`;

  return (
    <Portal>
      <div class="mp-toast-wrap" aria-live="polite" aria-atomic="true">
        <For each={items()}>{(t) => (
          <div class={cardClass(t.kind)} style={`--mp-toast-ttl:${t.ttl}ms`} data-toast-ttl={t.ttl}>
            <span class="mp-toast-ico" aria-hidden="true">
              {t.kind === 'success' ? '✅' : t.kind === 'error' ? '⚠️' : t.kind === 'warning' ? '⚠️' : 'ℹ️'}
            </span>
            <span class="mp-toast-text">{t.text}</span>
            <div class="mp-toast-progress" aria-hidden="true">
              <span class="mp-toast-progress-bar" />
            </div>
          </div>
        )}</For>
      </div>
    </Portal>
  );
}

